// AMF / CFL pitch-view toggle.
//
// Two modes:
//  - "Pass Chart" (default) — every throw's start X collapsed to a shared
//    line so coaches can read direction/distance/outcome spread at a glance.
//    Matches NFL analytics terminology (PFF, NextGen Stats).
//  - "Full Pitch" — throws drawn at their true field coordinates on the
//    regular AMF/CFL pitch.
import { ToggleGroup, ToggleGroupItem } from '@frontend/ui'

export type PitchViewMode = 'pass-chart' | 'full'

interface PitchViewToggleProps {
  value: PitchViewMode
  onChange: (mode: PitchViewMode) => void
}

export function PitchViewToggle({ value, onChange }: PitchViewToggleProps) {
  return (
    <ToggleGroup
      type='single'
      variant='outline'
      size='sm'
      value={value}
      onValueChange={(v) => {
        if (v === 'pass-chart' || v === 'full') onChange(v)
      }}
    >
      <ToggleGroupItem value='pass-chart' className='px-3'>
        Pass Chart
      </ToggleGroupItem>
      <ToggleGroupItem value='full' className='px-3'>
        Full Pitch
      </ToggleGroupItem>
    </ToggleGroup>
  )
}
